import { getWindow } from './getWindow';

const REGEXP_SCROLL_PARENT = /^(visible|hidden)/;
/**
 * Encuentra el primer elemento padre del elemento provisto que tenga scroll
 * activo.
 */
export function findScrollContainer(el: HTMLElement): HTMLElement | null {
  // eslint-disable-next-line no-nested-ternary
  const found =
    !(el instanceof HTMLElement) ||
    typeof getWindow().getComputedStyle !== 'function'
      ? null
      : el.scrollHeight >= el.clientHeight &&
          !REGEXP_SCROLL_PARENT.test(
            getWindow().getComputedStyle(el).overflowY || 'visible',
          )
        ? el
        : findScrollContainer(el.parentElement as HTMLElement) ||
          (document as unknown as HTMLElement);

  if (found === document.body) {
    return document.body.parentElement!;
  }

  return found;
}
